'use client';

import { useEffect } from 'react';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import posthog, { posthogInit } from '@/lib/posthog';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const consent = localStorage.getItem('zibarit_cookie_consent');
    if (consent === 'rejected') return;
    posthogInit();
    if (consent === 'accepted') {
      posthog.opt_in_capturing();
    }
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
